module.exports = __webpack_public_path__ + "static/img/wave-direction.655da846.png";